var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-layout-design"},[(_vm.loading)?_c('LoadingSpinner'):_c('div',[_c('CompanyLogo',{attrs:{"wizard":false,"show-name":false,"type":_vm.type}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }